import React, { useState } from "react";
import "./Testimonials.css";
import { testimonialsData } from "../../data/testimonialsData";
import leftarrow from "../../assets/leftArrow.png";
import rightarrow from "../../assets/rightArrow.png";

const Testimonials = () => {
  const [selected, setSelected] = useState(0);
  const tLength = testimonialsData.length; // Corrected variable name for consistency

  // Function to go to the previous testimonial
  const handlePrev = () => {
    setSelected((prev) => (prev === 0 ? tLength - 1 : prev - 1));
  };

  // Function to go to the next testimonial
  const handleNext = () => {
    setSelected((prev) => (prev === tLength - 1 ? 0 : prev + 1));
  };

  return (
    <div className="Testimonials" id="testimonials"> {/* Added id for potential navigation */}
      <div className="left-t">
        <span className="testimonials-heading-small">Testimonials</span> {/* Added class for specific styling */}
        <span className="stroke-text">What they</span> {/* Changed class to stroke-text */}
        <span>say about us</span>
        <span className="review-text">{testimonialsData[selected].review}</span> {/* Added class for review text */}
        <span className="author-info">
          <span className="author-name">{testimonialsData[selected].name}</span>{" "}
          - {testimonialsData[selected].status}
        </span>

        <div className="arrows"> {/* Moved arrows to left-t as per image */}
          <img
            onClick={handlePrev}
            src={leftarrow}
            alt="Previous Testimonial"
          />
          <img
            onClick={handleNext}
            src={rightarrow}
            alt="Next Testimonial"
          />
        </div>
      </div>

      <div className="right-t">
        <div className="border-shape"></div> {/* For the yellow/orange border */}
        <div className="filled-shape"></div> {/* For the orange/red filled rectangle */}
        <img
          key={selected} // Add key to force re-render and trigger transition
          src={testimonialsData[selected].image}
          alt={`Testimonial by ${testimonialsData[selected].name}`}
          className="testimonial-image"
        />
      </div>
    </div>
  );
};

export default Testimonials;